module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box american-credit-partner"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_c('h1', [_vm._v("Business financing blog & latest news")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#f6f9ff"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#f6f9ff"
    }
  }, [_c('blog-card', {
    attrs: {
      "blogLink": "static/blog/invoice-accounts-receivable-factoring-vs-financing.html",
      "name": "What is the Difference between Receivable Financing vs Factoring",
      "category": "Finance And Accounting",
      "image": "invoice-accounts-receivable-factoring-vs-financing.jpg",
      "date": "May 9, 2022",
      "desc": "The primary difference between factoring and bank financing with accounts receivables involves the ownership of the invoices. Factors actually buy your invoices at a discounted rate, while banks require you to pledge or assign the invoices..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/invoice-factoring-explained.html",
      "name": "What Does Invoice Factoring Mean?",
      "category": "Finance And Accounting",
      "image": "invoice-factoring-explained.jpg",
      "date": "May 6, 2022",
      "desc": "Invoice factoring and account receivable financing have been used interchangeably. Although they are not exactly the same, they both entail using invoice/accounts receivables to access funds quickly for working capital..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/equipment-financing-application-submission-guidelines-and-rationales.html",
      "name": "Equipment Financing Application Submission Guidelines and Rationales",
      "category": "Finance And Accounting",
      "image": "american_credit_credit_application.jpeg",
      "date": "May 21, 2021",
      "desc": "When apply for an equipment financing for your business, either through full purchase (EFA) or leasing, you want the application process to be smooth, efficient, and hassle free. The followings are guidelines and rationales that can help you understand..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/credit-ratings-and-application-documents-requirements.html",
      "name": "Credit Ratings and Application Documents (no-doc to full-docs) Requirements",
      "category": "Loans And Funding",
      "image": "american_credit_credit_ratings_1.jpeg",
      "date": "May 7, 2021",
      "desc": "Credit ratings (A, B, C, D) give a quick letter grade to an individual’s credit history. This allows financial institutions to determine how likely an individual will pay money back if given a loan, as well as employers to verify how responsible..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/fair-market-value-lease-vs-one-dollar-buyout-lease.html",
      "name": "Fair Market Value (FMV) lease vs. $1 Dollar Buyout Lease (Equipment Financing Agreement, EFA)",
      "category": "Finance And Accounting",
      "image": "american_credit_FMV_vs_EFA.jpeg",
      "date": "April 27, 2021",
      "desc": "Are you considering adding equipment to improve operations and boost productivity in your business? Instead of buying expensive equipment outright you could consider leasing new equipment. Leasing offers an affordable way to acquire, upgrade, or..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/why-small-businesses-look-for-ar-factoring-opportunities.html",
      "name": "Why Small Businesses Look for AR Factoring Opportunities",
      "category": "Finance And Accounting",
      "image": "american_credit_ar_factoring_opportunities.jpeg",
      "date": "October 8, 2020",
      "desc": "Small businesses are at the mercy of their clients. If you have slow-paying clients, you could find yourself unable to cover your bills due to a lack of cash flow or with the inability to grow your business even when faced with the opportunity..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/situations-an-account-receivable-financing-company-can-help-you.html",
      "name": "Situations an Account Receivable Financing Company Can Help You",
      "category": "Small Business Tips",
      "image": "american_credit_accounts_receivable.jpeg",
      "date": "September 9, 2020",
      "desc": "Businesses need cash flow to operate, but sometimes the cash flow isn’t there – it’s stuck in the unpaid invoices your clients haven’t paid yet. In other words, you have the business, but the money isn’t in your possession quite yet. Without proper..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/everything-you-need-to-know-about-asset-based-loans-tips-for-securing-one-for-your-business.html",
      "name": "Everything you need to know about asset-based loans: Tips for securing...",
      "category": "Finance And Accounting",
      "image": "american_credit_asset_based_lending.jpeg",
      "date": "August 10, 2020",
      "desc": "An asset-based loan is a certain kind of business financing that is secured by the company assets. Many of the asset-based loans work as the revolving lines of credits. This permits a company to lend from assets continuously for covering the investments..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/The-Top-Factors-to-Look-for-When-Hiring-an-AR-Financing-Company.html",
      "name": "The Top Factors to Look for When Hiring an AR Financing Company",
      "category": "Small Business Tips",
      "image": "american_credit_AR_financing.jpeg",
      "date": "July 17, 2020",
      "desc": "Hiring an AR financing company is a great way to give your company liquidity while you wait for invoices to be paid. AR factoring or financing helps your company stay afloat, paying its bills on time and possibly even growing while you wait for..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/maintain-robust-cash-flow-here-are-4-handy-tips-to-do-so.html",
      "name": "Maintain Robust Cash Flow: Here are 4 Handy tips to do so!",
      "category": "Small Business Tips",
      "image": "american_credit_maintain_robust_cash_flow.jpeg",
      "date": "June 22, 2020",
      "desc": "As a business owner having a positive cash flow is advantageous and necessary for your operations. Yes, by doing so, you can make payments, venture into new investments, and develop your business. The experts opine that business owners who..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/quick-invoice-financing-your-partner-for-business-growth.html",
      "name": "Quick Invoice Financing - Your Partner for Business Growth",
      "category": "Finance And Accounting",
      "image": "american_credit_fast_invoice_financing.jpeg",
      "date": "June 10, 2020",
      "desc": "Cash flow is the common challenges that businesses have to overcome. There are two reasons where businesses borrow money, it is to expand the business or solve cash flow issues. Let’s say your customer is calling and places a big order with you..."
    }
  }), _vm._v(" "), _c('blog-card', {
    attrs: {
      "blogLink": "static/blog/what-makes-construction-equipment-loan-advantageous.html",
      "name": "What makes construction equipment loan advantageous?",
      "category": "Finance And Accounting",
      "image": "construction_equipment.jpeg",
      "date": "March 4, 2020",
      "desc": "If you are running a small business and involved in any type of construction job, you should know that your business will require heavy equipment. But the heavy equipment that your business needs will also come with a hefty price tag..."
    }
  }), _vm._v(" "), _c('blog-card', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "blogLink": "static/blog/AmericanCreditandLeiLi.html",
      "name": "American Credit and its founder Dr. Lei Li",
      "category": "American Credit Updates",
      "image": "AdobeStock_250051419.jpg",
      "date": "November 4, 2019",
      "desc": "American Credit provides business loans to small and medium businesses (SMB) in California, with a plan to expand nation-wide in the near future. Business owners apply online in minutes, either through our website or APP..."
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#ffffff",
      "color": "rgb(84, 86, 255)",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "1px solid rgb(84, 86, 255)",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        return this.window.open('https://youtu.be/JH96Q66Y4Hc', '_blank')
      }
    }
  }, [_vm._v("Watch Demo")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback american-credit-blog-feedback"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Equipment Financing Customer Vioce Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("Banks don’t understand how fleeting opportunities are. With a loan right now, we could upgrade our equipment and easily handle all the new business.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("Let’s Talk")]), _vm._v(" "), _vm._m(5)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Get the credit you deserve from a lender you can trust. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "american-credit-blog-head-img",
    attrs: {
      "src": require("../assets/imgs/American_Credit_Blog.png"),
      "alt": "American Credit Blog"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#053a7a"
    }
  }, [_c('div', {
    staticClass: "container bluebg text-center"
  }, [_c('br'), _vm._v(" "), _c('h2', {
    staticClass: "display-5 text-whitee text-center font-weight-bold"
  }, [_vm._v("News, views and resources from a leading secured business loan lender")]), _vm._v(" "), _c('div', {
    staticClass: "contexbox text-center"
  }, [_c('br'), _vm._v(" "), _c('h3', {
    staticClass: "text-whitee text-center font-weight-bold"
  }, [_vm._v("Trends, business financing articles, resources and more")]), _vm._v(" "), _c('p', {
    staticClass: "text-white h-line-height"
  }, [_vm._v("Most of our asset-based loans and invoice/AR financing clients are from the small business community, a dynamic and ever-evolving community. So, to help our clients stay ahead of the game, we bring together everything from best-practice advice for small business management to market trends and perspectives on new opportunities from experts.")])]), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Equipment_Financing_Customer_Vioce.png"),
      "alt": "American Credit Equipment Financing Customer Vioce"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("Drew Arcelay")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("President, South Field Construction Company")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d1a6daa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog.vue
// module id = 1941
// module chunks = 5